import { combineReducers } from "redux";

import earningsSummary from "./earningsSummaryReducer";
import paymentMethod from "./paymentMethodReducer";
import paymentNotifications from "./paymentNotificationReducer";
import placements from "./placementReducer";
import statements from "./statementReducer";
import transactions from "./transactionReducer";
import stripeAccount from "./stripeAccountReducer";
import costCenterInvoicePeriods from "./costCenterInvoicePeriodReducer";

export default combineReducers({
  statements,
  transactions,
  placements,
  paymentNotifications,
  paymentMethod,
  earningsSummary,
  stripeAccount,
  costCenterInvoicePeriods,
});
